import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from '@mui/material';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import { MessageTransport } from '@common/clientServerApi';
import { CHANNEL_LABELS } from '@common/candidateChannels';
export const CHANNEL_ICONS = {
    [MessageTransport.Sms]: SmsOutlinedIcon,
    [MessageTransport.WhatsApp]: WhatsAppIcon,
    [MessageTransport.Email]: MailOutlineRoundedIcon,
};
/** Which channel a message went out on or came in through. */
export function MessageChannelBadge({ channel }) {
    const Icon = CHANNEL_ICONS[channel];
    return (_jsx(Chip, { "data-testid": "message-channel-badge", size: "small", variant: "outlined", icon: _jsx(Icon, {}), label: CHANNEL_LABELS[channel], sx: {
            height: 20,
            fontSize: '0.75rem',
            color: 'text.secondary',
            '& .MuiChip-icon': { fontSize: 14, ml: 0.5, color: 'text.secondary' },
            '& .MuiChip-label': { px: 0.75 },
        } }));
}
